import Switch from '@ui/switch/switch';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import ColorPill from '../controls/color-pill';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setCampaignEditorField } from '@/store/slices/campaign-editor';
import {
  selectBackgroundColor,
  selectContainerColor,
  selectHideBrandliveLogo,
} from '@/store/slices/campaign-editor/selectors';

interface ContentBlocksTopSectionProps {
  // the resolved colors shown - the campaign's own, else the theme's, else the template's
  backdropColor: string;
  pageColor: string;
}

export default function ContentBlocksTopSection({ backdropColor, pageColor }: ContentBlocksTopSectionProps) {
  const dispatch = useAppDispatch();
  // a campaign color is only set when it overrides the theme's or the template's
  const backgroundColor = useAppSelector(selectBackgroundColor);
  const containerColor = useAppSelector(selectContainerColor);
  const hideBrandliveLogo = useAppSelector(selectHideBrandliveLogo);
  const setBackdropColor = (value: string) => dispatch(setCampaignEditorField({ key: 'backgroundColor', value }));
  const setPageColor = (value: string) => dispatch(setCampaignEditorField({ key: 'containerColor', value }));

  return (
    <>
      <Container className="flex gap-8" padding="0 16px">
        <ColorPill
          label="Backdrop color"
          value={backdropColor}
          isOverridden={!!backgroundColor}
          onChange={setBackdropColor}
          onReset={() => setBackdropColor('')}
        />
        <ColorPill
          label="Page color"
          value={pageColor}
          isOverridden={!!containerColor}
          onChange={setPageColor}
          onReset={() => setPageColor('')}
        />
      </Container>

      <Container
        className="flex ai-center jc-space-between"
        margin="0 16px"
        padding="12px 16px"
        background="var(--gray-900)"
        borderRadius="12px"
        design="GlobalCont2"
      >
        <Text className="P2" color="var(--global-ico-text-2)">
          Hide Brandlive Logo
        </Text>
        <Switch
          value="hideBrandliveLogo"
          on={hideBrandliveLogo}
          onClick={(_, on) => dispatch(setCampaignEditorField({ key: 'hideBrandliveLogo', value: on }))}
        />
      </Container>

      <Text className="P2 padding-h-16" color="var(--global-ico-text-3)">
        Drag to add to your email
      </Text>
    </>
  );
}
